import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios/axiosInstance';

export const fetchAllPaymentsByAdmin = createAsyncThunk(
  'payments/fetchAllPaymentsByAdmin',
  async (params = {}, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get('/admin/payments', { params });
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: 'Failed to fetch payments' }
      );
    }
  }
);

export const fetchPaymentsSummary = createAsyncThunk(
  'payments/fetchPaymentsSummary',
  async (params = {}, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get('/admin/payments/summary', { params });
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: 'Failed to fetch payments summary' }
      );
    }
  }
);

